import {
  PlatformAppEvent,
  PlatformAppEventEmitter,
  IPlatformAppEvent,
} from '@wix/public-editor-platform-events';
import { AllowedEvents, AppEventPayload, PrivateAPIFixMe } from './types';
import { transformEventPayload } from './transformEventPayload';

export type OmitEventMeta<T> = T extends { meta: any } ? Omit<T, 'meta'> : T;

/**
 * TODO: should not be in this package
 */
export class ApplicationBoundEvents {
  private events: PlatformAppEventEmitter;
  public subscribe;
  public commit;
  public startTransaction;
  public silent;

  constructor(
    private appDefinitionId: string | null,
    events: PlatformAppEventEmitter,
    private privateAPI: PrivateAPIFixMe,
  ) {
    this.events = events;
    this.subscribe = events.subscribe.bind(events);
    this.commit = events.commit.bind(events);
    this.startTransaction = events.startTransaction.bind(events);
    this.silent = events.silent.bind(events);
  }

  public notify(event: OmitEventMeta<IPlatformAppEvent>) {
    this.events.notify({
      type: event.type,
      payload: event.payload,
      meta: {
        appDefinitionId: this.appDefinitionId,
      },
    } as IPlatformAppEvent);
  }

  notifyCustomEvent(type: string, payload: Record<string, string>) {
    this.notify({
      type: PlatformAppEvent.CustomEvent,
      payload: {
        ...payload,
        type,
      },
    });
  }

  /**
   * TODO: we should use same interface for all events
   * (subscribe vs addEventListener)
   */
  public addEventListener<EventType extends AllowedEvents>(
    eventType: EventType,
    fn: (payload: AppEventPayload<EventType>) => void,
  ) {
    return this.events.subscribe(async (event) => {
      const isAppMatch =
        event.meta?.appDefinitionId === this.appDefinitionId ||
        event.meta?.appDefinitionId === null;

      const transformPayload = () =>
        transformEventPayload<EventType>(event.payload, this.privateAPI);

      // as an exception to skip autocomplete
      if ((eventType as string) === '*') {
        fn(await transformPayload());
        /**
         * We need to check for app match here to not listen app's own events
         */
      } else if (event.type === PlatformAppEvent.CustomEvent) {
        if (eventType === event.payload?.type && !isAppMatch) {
          fn(await transformPayload());
        }
      } else if (event.type === PlatformAppEvent.HostEvent) {
        if (eventType === event.payload?.type && isAppMatch) {
          fn(await transformPayload());
        }
      }
    });
  }
}
